import { integrationCreated } from '@/common/analytics/Avo';
import type { WorkIntegration_Keys } from '@/common/api/types/workIntegrations';

interface TrackIntegrationCreatedParams {
  integrationId: number;
  integrationSource: WorkIntegration_Keys;
  integrationInstanceUrl: string;
  integrationInstanceId: string;
  integrationProjectId: string;
  loopId: number;
}

export const trackIntegrationCreated = ({
  integrationId,
  integrationSource,
  integrationInstanceUrl,
  integrationInstanceId,
  integrationProjectId,
  loopId,
}: TrackIntegrationCreatedParams) => {
  integrationCreated({
    integrationId: String(integrationId),
    integrationSource,
    integrationInstanceUrl,
    integrationInstanceId,
    integrationProjectId,
    loopId: String(loopId),
  });
};
